import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { searchPOSPatients } from 'actions/EntityActions';
import { idOrderHistoryDialog, assignMember } from 'actions/EntityActions';
import { initializeStorePOSPatient } from 'actions/FormActions';
import { selectPOSPatientSearchModel } from 'selectors/entitySelector';
import MaskedTextInput from 'screens/components/advanced/MaskedTextInput';
import Pagination from 'screens/components/basic/Pagination';
import DialogInput from 'screens/components/advanced/DialogInput';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import CheckInput from 'screens/components/basic/CheckInput';
import { Divider } from '@mui/material';
import POSOrderHistory from './POSOrderHistory';
import { getPatientOrders } from 'actions/EntityActions';
import PatientSave from '../../user/patient/PatientSave';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

const statusList = 'LIST';

const dialogStyle = {
    width: '70%',
    maxWidth: 'none'
};

class POSAssignMember extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isAdditionalInformationOpen: false,
            additionalInformation: null,
            status: statusList,
            activePage: 1,
            itemsPerPage: 5,
            showOrderHistoryDialog: false,
            editMemberOpen: false,
            selectedMemberId: 0
        };

        this.search = this.search.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.isOpen === false && newProps.isOpen === true) {
            this.props.initializeStorePOSPatient();
        }
    }

    search = (page = 1) => {
        let filter = this.props.patientSearchModel;
        filter.page = page;
        filter.itemsPerPage = this.state.itemsPerPage;
        filter.branchId = this.props.branchId;
        this.props.search(filter);
    }

    pageChange = (page) => {
        this.setState({ activePage: page });
        this.search(page);
    }

    linkPatientToOrder = (patient) => {
        this.props.assignMember({ Id: this.props.posOrder.id, PatientId: patient.id });
        this.props.onClose();
    }

    showOrderHistory = (id) => {
        this.props.setIDOrderHistory(id);
        this.getOrders(id);
        this.setState({ showOrderHistoryDialog: true });
    }

    onClose = () => {

        this.props.onClose();
    }

    getOrders = (id) => {
        const model = {
            branchId: 0,
            orderNumber: null,
            orderDate: null,
            patientFirstName: "",
            employeeFirstName: "",
            status: 'None',
            total: null,
            orderBy: "DESC",
            sortBy: "Id",
            innerClass: "",
            employeeId: null,
            patientId: id,
            page: 1,
            itemsPerPage: 10
        }

        this.props.getPatientOrders(model);
    }

    onAdditionalInformationClose = () => {
        this.setState({ isAdditionalInformationOpen: false, additionalInformation: null });
    }

    openAdditionalInformationDialog = (notes) => {
        this.setState({ isAdditionalInformationOpen: true, additionalInformation: notes });
    }

    openEditMemberDialog = (memberId) => {
        this.setState({ editMemberOpen: true, selectedMemberId: memberId });
    }

    closeEditMemberDialog = () => {
        this.setState({ editMemberOpen: false, selectedMemberId: 0 });
    }

    onKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.target.blur();
            this.search();
        }
    }

    closeOrderHistoryDialog = () => {
        this.setState({ showOrderHistoryDialog: false })
    }

    render() {
        const { t } = this.props;
        const p = this.props;
        const s = this.state;

        const actions = [
            <Button
                key={1}
                type="CancelButton"
                className="btn-space"
                label={t('pos.assignMember.cancelText')}
                secondary={true}
                onTouchTap={() => this.onClose()}
            />,
            <Button
                key={2}
                className="pull-right btn-space"
                type="RaisedButton"
                label={t('common.search')}
                onTouchTap={() => this.search()}
            />
        ];

        const patients = p.posPatients.map((item, index) => {
            return (
                <div key={index}>
                    <div className="media">
                        <div className="media-left media-top">
                            <img src={item.photo} className="media-object media-photo" />
                        </div>
                        <div className="media-body">
                            <h6 className="media-heading">{`${item.firstName} ${item.lastName} ${item.preferredName ? ' (' + item.preferredName + ')' : ''}`} <span className="pull-right">{item.dateOfBirth}</span></h6>
                            <p>{t('common.member')} #{item.id}</p>
                            <p>{item.notes}</p>

                            {p.springbigApiKey == "" && p.alpineIQApiKey == "" && <p>{t('pos.assignMember.rewardPoints')} {item.rewardPoints}</p>}

                            <Button
                                className="pull-right"
                                type="RaisedButton"
                                label={t('pos.assignMember.assignMember')}
                                onTouchTap={() => this.linkPatientToOrder(item)}
                            />
                            {
                                item.additionalInformation ? (
                                    <Button
                                        type="FlatButtonPrimary"
                                        name="openNotes"
                                        label={t('pos.assignMember.readNotes')}
                                        className="mr-2"
                                        onTouchTap={() => this.openAdditionalInformationDialog(item.additionalInformation)} />
                                ) : null
                            }
                            <Button
                                type="RaisedButton"
                                className="ml-1"
                                label={t('pos.assignMember.viewOrderButton')}
                                onTouchTap={() => this.showOrderHistory(item.id)}
                            />
                            <br />
                            <br />
                            <Button
                                type="FlatButtonPrimary"
                                label={t('pos.assignMember.viewMemberButton')}
                                onTouchTap={() => this.openEditMemberDialog(item.id)}
                            />
                        </div>
                    </div>
                    <br />
                    <Divider />
                    <br />
                </div>
            );
        });

        return (
            <React.Fragment>
                <DialogInput
                    title={<DialogHeaderWithClose text={t('pos.assignMember.viewMember')} handleClose={() => this.closeEditMemberDialog()}/>}
                    actions={actions}
                    modal={true}
                    open={p.isOpen}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}>
                        <div className="row">
                            <div className="col-lg-12">
                                <TextInput name={p.name + "CardNumber"}
                                    label={t('common.cardNum')}
                                    floatingLabelText={t('common.cardNum')}
                                    hintText={t('common.cardNum')}
                                    onKeyPress={this.onKeyPress}
                                    fullWidth={true} />
                            </div>
                            <div className="col-lg-6">
                                <TextInput name={p.name + "FirstName"}
                                    label={t('common.firstName')}
                                    floatingLabelText={t('common.firstName')}
                                    hintText={t('common.firstName')}
                                    onKeyPress={this.onKeyPress}
                                    fullWidth={true} />
                            </div>
                            <div className="col-lg-6">
                                <TextInput name={p.name + "LastName"}
                                    label={t('common.lastName')}
                                    floatingLabelText={t('common.lastName')}
                                    hintText={t('common.lastName')}
                                    onKeyPress={this.onKeyPress}
                                    fullWidth={true} />
                            </div>
                            <div className="col-lg-6">
                                <TextInput name={p.name + "PreferredName"}
                                    label={t('common.preferredName')}
                                    floatingLabelText={t('common.preferredName')}
                                    hintText={t('common.preferredName')}
                                    onKeyPress={this.onKeyPress}
                                    fullWidth={true} />
                            </div>
                            <div className="col-lg-6">
                            <TextInput name={p.name + "Email"}
                                    label={t('common.email')}
                                    floatingLabelText={t('common.email')}
                                    hintText={t('common.email')}
                                    onKeyPress={this.onKeyPress}
                                    fullWidth={true} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <TextInput name={p.name + "MemberNumber"}
                                    label={t('pos.assignMember.memberNumber.label')}
                                    floatingLabelText={t('pos.assignMember.memberNumber.label')}
                                    hintText={t('pos.assignMember.memberNumber.hintText')}
                                    onKeyPress={this.onKeyPress}
                                    autoFocus={true}
                                    fullWidth={true} />
                            </div>
                            <div className="col-lg-6">
                                <MaskedTextInput
                                    fullWidth={true}
                                    name={p.name + "Phone"}
                                    floatingLabelText={t('common.phone')}
                                    hintText={t('common.phone')}
                                    onKeyPress={this.onKeyPress}
                                    mask="(999) 999-9999" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <CheckInput name={p.name + "IsNotMember"} text={t('pos.assignMember.isNotMember.label')}  className="d-inline-block" />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                {
                                    patients && patients.length > 0 ?
                                        (
                                            <div>
                                                <h4>{t('common.members')}</h4>
                                                <Divider />
                                                <br />
                                            </div>
                                        ) : null
                                }
                                {patients}
                                <Pagination
                                    length={p.posPatientsLength || 0}
                                    itemsPerPage={s.itemsPerPage}
                                    activePage={s.activePage}
                                    onPageChange={(e) => this.pageChange(e)} />
                            </div>
                        </div>
                </DialogInput>

                <POSOrderHistory isOpen={this.state.showOrderHistoryDialog} onCancel={() => this.closeOrderHistoryDialog()} />

                <DialogInput
                    title="Member Additional Information"
                    actions={
                        <Button
                            type="CancelButton"
                            className="btn-space"
                            label={t('common.close')}
                            secondary={true}
                            onTouchTap={() => this.onAdditionalInformationClose()}
                        />}
                    modal={true}
                    open={s.isAdditionalInformationOpen}
                    autoScrollBodyContent={true}
                    contentStyle={dialogStyle}>
                    <div className="row">
                        <div className="col-lg-12" style={{ whiteSpace: 'pre-line' }}>
                            <br />
                            <p>{s.additionalInformation}</p>
                        </div>
                    </div>
                </DialogInput>
                <DialogInput
                    title={<DialogHeaderWithClose text={t('pos.assignMember.viewMember')} handleClose={() => this.closeEditMemberDialog()}/>}
                    modal={true}
                    open={this.state.editMemberOpen}
                    autoScrollBodyContent={true}
                    className="transfer_Product checkIn_list"
                    handleClose={() => this.closeEditMemberDialog()}
                    contentStyle={dialogStyle}>
                    <div className="no-crumb">
                        <PatientSave patientId={this.state.selectedMemberId} isDialog={true} closeDialog={() => this.closeEditMemberDialog()} />
                    </div>
                </DialogInput>

            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        patientSearchModel: selectPOSPatientSearchModel(state, ownProps.name),
        posPatients: state.entity.posPatients,
        posPatientsLength: state.entity.posPatientsLength,
        posOrder: state.entity.posOrder,
        branchId: state.common.branchId,
        patientId: state.entity.idOrderHistoryDialog,
        store: state.common.store,
        springbigApiKey: state.common.applicationSettings.springbigApiKey || "",
        alpineIQApiKey: state.common.applicationSettings.alpineIQApiKey || ""
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        search: (filter) => dispatch(searchPOSPatients(filter)),
        completedOrderAssignPatient: (model) => dispatch(completedOrderAssignPatient(model)),
        initializeStorePOSPatient: () => dispatch(initializeStorePOSPatient(ownProps.name)),
        setIDOrderHistory: (id) => dispatch(idOrderHistoryDialog(id)),
        getPatientOrders: (model) => dispatch(getPatientOrders(model)),
        assignMember: (model) => dispatch(assignMember(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSAssignMember));
